import { 
    Box, 
    Card, 
    Typography, 
    TextField, 
    InputAdornment, 
    FormControl, 
    Radio, 
    InputLabel, 
    OutlinedInput, 
    IconButton, 
    Button, 
    RadioGroup, 
    Grid, 
    FormControlLabel 
} from '@mui/material'
import { useEffect, useState } from 'react'
import inetlogo from '../assets/images/Inet_logo.png'
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Loading from '../components/Loading';
import { useNavigate, useParams } from 'react-router-dom';
import { getStorage, setStorage } from '../utils/functions/localstorage';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { omit } from 'lodash';
import { swalErrorBtn } from '../helpers/swalHelper';
import AuthenticateApi from '../service/auth.api';
import NotFound from '../components/NotFound/NotFound';

function Register() {
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [merchantExists, setMerchantExists] = useState(null);

    const { merchantPath } = useParams();
    const token = getStorage('token');
    const navigate = useNavigate();
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleClickShowConfirmPassword = () => setShowConfirmPassword((show) => !show);

    const checkMerchant = async () => {
        try {
            const resp = await AuthenticateApi.checkMerchantApi(merchantPath);
            setMerchantExists(resp.data?.isExists);
        } catch (error) {
            console.log("error", error);
            setMerchantExists(false)
        }
    }
    
    const handleMouseDownPassword = (event) => { 
        event.preventDefault(); 
    };

    const handleMouseUpPassword = (event) => { 
        event.preventDefault(); 
    };
    
    const schema = yup.object().shape({
        accountTitle: yup
        .string()
        .required("กรุณาเลือกคำนำหน้าชื่อ"),
        firstName: yup
        .string()
        .required("กรุณากรอกชื่อ"),
        lastName: yup
        .string()
        .required("กรุณากรอกนามสกุล"),
        phoneNumber: yup
        .string()
        .matches(/^[0-9]+$/, "กรุณากรอกเบอร์โทรศัพท์เป็นตัวเลขเท่านั้น")
        .required("กรุณากรอกเบอร์โทรศัพท์")
        .max(10, "เบอร์โทรศัพท์ต้องมีอย่างน้อย 10 หลัก")
        .min(10, "เบอร์โทรศัพท์ต้องมีอย่างน้อย 10 หลัก"),
        username: yup
        .string()
        .required("กรุณากรอกชื่อผู้ใช้")
        .min(6, "ชื่อผู้ใช้ต้องมีอย่างน้อย 6 ตัวอักษร")
        .max(100, "ชื่อผู้ใช้ต้องไม่เกิน 100 ตัวอักษร")
        .matches(/^(?=.*[a-z])[a-z0-9]+$/, "ชื่อผู้ใช้ต้องประกอบด้วยตัวอักษรภาษาอังกฤษพิมพ์เล็กอย่างน้อย 1 ตัว และตัวเลขเท่านั้น")
        .transform((value) => value.toLowerCase()),
        password: yup
        .string()
        .required("กรุณากรอกรหัสผ่าน")
        .matches(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/, 'ต้องประกอบด้วยตัวอักษรภาษาอังกฤษผสมตัวเลขอย่างน้อยหนึ่งหลัก')
        .max(100, "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร")
        .min(8, "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร"),
        confirmPassword: yup
        .string()
        .required("กรุณายืนยันรหัสผ่าน")
        .oneOf([yup.ref('password'), null], "รหัสผ่านไม่ตรงกัน"),
    })

    const { register, handleSubmit, setValue, formState: { errors }, control } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        try {
            setIsLoading(true);
            const payload = omit(data, ['confirmPassword']);
            payload.urlPath = merchantPath;
            const resp = await AuthenticateApi.registerApi(payload);
            // console.log("resp", resp);
            if (resp.success) {
                window.setTimeout(() => {
                    window.location.reload();
                    navigate('/');
                }, 2000);
            } else {
                setIsLoading(false);
                swalErrorBtn({title: 'ลงทะเบียนไม่สำเร็จ'});
            }
        } catch (error) {
            console.log(error);
            setIsLoading(false);
            swalErrorBtn({title: 'ลงทะเบียนไม่สำเร็จ'});
        }
    };

    const handleUsernameChange = (e) => {
        const value = e.target.value.toLowerCase();
        setValue("username", value);
    }

    useEffect(() => {
        if(merchantPath && !token) {
            setStorage('merchantPath', merchantPath);
        }
    }, [merchantPath])

    useEffect(() => {
        checkMerchant();
    }, [merchantPath])

    if (merchantExists === false) {
        return <NotFound />;
    }

  return token ? (
    navigate('/')
  ) :(
    <div
        style={{
            height: '135vh',
            background: 'linear-gradient(to left top, #bcfbc5, #aff5c3, #a3eec0, #96e8be, #8ae1bc, #81dab8, #78d3b3, #6fccaf, #67c3a8, #5fbaa1, #57b19a, #4fa893)',
        }}
    >
        <Loading isLoading={isLoading} />
        <div className="flex h-screen">
        <div className="m-auto">
          <div className="px-6 py-4">
            <Card
              sx={{
                // height: 550,
                borderRadius: 2,
                padding: 2,
                position: 'relative',
                boxShadow:
                  '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
              }}
            >
              <Box
                sx={{
                  maxWidth: 400,
                  padding: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <img src={inetlogo} alt="inet logo" className='w-[140px] mb-6'/>
                <span className='mb-2'>ลงทะเบียนเข้าสู่ระบบ</span>
                <Typography component="h1" variant="h5" sx={{ fontWeight: 'medium' }} className='text-[#4FA893]'>
                  Bill Payment Lite
                </Typography>
                <Box noValidate sx={{ mt: 4 }} component="form" onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12}>
                            <span className='flex justify-start text-sm text-gray-600'>คำนำหน้าชื่อ</span>
                            <FormControl fullWidth >
                                <Controller
                                    name="accountTitle"
                                    control={control}
                                    render={({ field }) => (
                                        <RadioGroup {...field} row 
                                            sx={{
                                                justifyContent: 'center',
                                                display: 'flex',
                                                gap: 1,
                                            }}
                                        >
                                            <FormControlLabel
                                                value="นาย"
                                                control={<Radio />}
                                                label="นาย"
                                            />
                                            <FormControlLabel
                                                value="นาง"
                                                control={<Radio />}
                                                label="นาง"
                                            />
                                            <FormControlLabel
                                                value="นางสาว"
                                                control={<Radio />}
                                                label="นางสาว"
                                            />
                                        </RadioGroup>
                                    )}
                                />
                            </FormControl>
                            {errors.accountTitle && <p className='text-red-500 flex justify-start text-xs p-1'>{errors.accountTitle.message}</p>}
                        </Grid>

                        {/* ชื่อ */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                sx={{ mb: 1 }}
                                fullWidth
                                label="ชื่อ (ภาษาไทย)"
                                variant="outlined"
                                placeholder="ชื่อ"
                                {...register("firstName")}
                                error={!!errors.firstName}
                                helperText={errors.firstName?.message}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <PersonIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        {/* นามสกุล */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                sx={{ mb: 1 }}
                                fullWidth
                                label="นามสกุล (ภาษาไทย)"
                                variant="outlined"
                                placeholder="นามสกุล"
                                {...register("lastName")}
                                error={!!errors.lastName}
                                helperText={errors.lastName?.message}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <PersonIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        {/* เบอร์โทรศัพท์ */}
                        <Grid item xs={12}>
                            <TextField
                                sx={{ mb: 1 }}
                                fullWidth
                                label="เบอร์โทรศัพท์"
                                variant="outlined"
                                placeholder="เบอร์โทรศัพท์"
                                {...register("phoneNumber")}
                                error={!!errors.phoneNumber}
                                helperText={errors.phoneNumber?.message}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <LocalPhoneIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        {/* ชื่อผู้ใช้ */}
                        <Grid item xs={12} md={12}>
                            <TextField
                                sx={{ mb: 1 }}
                                fullWidth
                                label="ชื่อผู้ใช้"
                                variant="outlined"
                                placeholder="ชื่อผู้ใช้"
                                {...register("username")}
                                onChange={handleUsernameChange}
                                error={!!errors.username}
                                helperText={errors.username?.message}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <PersonIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        {/* รหัสผ่าน */}
                        <Grid item xs={12} md={12}>
                            <FormControl variant="outlined" required fullWidth>
                                <InputLabel htmlFor="outlined-adornment-password">รหัสผ่าน</InputLabel>
                                <OutlinedInput
                                    sx={{ mb: 1 }}
                                    id="outlined-adornment-password"
                                    type={showPassword ? 'text' : 'password'}
                                    {...register("password")}
                                    error={!!errors.password}
                                    helperText={errors.password?.message}
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <LockIcon />
                                        </InputAdornment>
                                    }
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label={showPassword ? 'hide the password' : 'display the password'}
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                                onMouseUp={handleMouseUpPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    label="รหัสผ่าน"
                                    placeholder="รหัสผ่าน"
                                />
                                {errors.password && <p className='text-red-500 flex justify-start text-xs p-2'>{errors.password.message}</p>}
                            </FormControl>
                        </Grid>
                        {/* ยืนยันรหัสผ่าน */}
                        <Grid item xs={12} md={12}>
                            <FormControl variant="outlined" required fullWidth>
                                <InputLabel htmlFor="outlined-adornment-password">ยืนยันรหัสผ่าน</InputLabel>
                                <OutlinedInput
                                    id="outlined-adornment-password"
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    {...register("confirmPassword")}
                                    error={!!errors.confirmPassword}
                                    helperText={errors.confirmPassword?.message}
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <LockIcon />
                                        </InputAdornment>
                                    }
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label={showConfirmPassword ? 'hide the password' : 'display the password'}
                                                onClick={handleClickShowConfirmPassword}
                                                onMouseDown={handleMouseDownPassword}
                                                onMouseUp={handleMouseUpPassword}
                                                edge="end"
                                            >
                                                {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    label="ยืนยันรหัสผ่าน"
                                    placeholder="ยืนยันรหัสผ่าน"
                                />
                                {errors.confirmPassword && <p className='text-red-500 flex justify-start text-xs p-2'>{errors.confirmPassword.message}</p>}
                            </FormControl>
                        </Grid>
                    </Grid>

                  <Button
                    type='submit'
                    fullWidth
                    variant='contained'
                    sx={{ borderRadius: 5, mt: 4, height: '42px', color: '#FFF', textTransform: 'none' }}
                  >
                    {/* Sign Up */}
                    ลงทะเบียน
                  </Button>

                  <Button
                    onClick={() => navigate(`/${merchantPath}`)}
                    fullWidth
                    variant='outlined'
                    sx={{ borderRadius: 5, mt: 2, height: '42px', textTransform: 'none' }}
                  >
                    กลับสู่หน้าหลัก
                  </Button>
                </Box>
              </Box>
            </Card>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Register